import { observer } from 'mobx-react';
import React from 'react';
import placementTestReportTestDialogService from '../../services/PlacementTesReportTestDialogService';
import ErrorsPerLevelChart from './ErrorsPerLevelChart';

function DetailErrorsPerLevelChartContainer() {
  return <ErrorsPerLevelChart data={placementTestReportTestDialogService.errorsPerLevel} />;
}

export default observer(DetailErrorsPerLevelChartContainer);
